export const LOGO_URL = "https://customer-assets-agu9un31.emergentagent.net/job_proform-body/artifacts/p3gmhp4i_Proform%20blk.png";
export const LOGO_FALLBACK = "https://customer-assets-rejwkqb3.emergentagent.net/job_a81177fb-08f4-43ae-982f-c3d75c61ebec/artifacts/e9cfu9vt_Proform.jpg";

export const BRAND = {
  name: "ProForm Paint & Body",
  short: "ProForm",
  domain: "ProFormColorado.com",
  phoneDisplay: "720-839-8046",
  phoneRaw: "7208398046",
  email: "Cody@ProFormColorado.com",
  instagramHandle: "_pro_form_",
  instagramUrl: "https://www.instagram.com/_pro_form_/",
  city: "Denver",
  state: "Colorado",
  tagline: "Built Different. Finished Right.",
  founded: 2012,
};

// Curated imagery. Temporary — replace with real ProForm photography before launch.
export const IMAGES = {
  // Hero — supplied ProForm asset. R34 Skyline GT-R at Denver Union Station in the rain.
  hero: "https://customer-assets-agu9un31.emergentagent.net/job_proform-body/artifacts/1f25g3qp_R34%20Union%20station.png",
  // Hero — mobile portrait (same asset; browser crops via object-fit).
  heroMobile: "https://customer-assets-agu9un31.emergentagent.net/job_proform-body/artifacts/1f25g3qp_R34%20Union%20station.png",
  // "About / behind ProForm" — supplied ProForm asset. Nissan 240SX at Denver 303.
  builder240: "https://customer-assets-agu9un31.emergentagent.net/job_proform-body/artifacts/412qo4t6_240.png",
  // "When other shops won't touch it" — dark stealth performance coupe with red taillight glow, deep negative space.
  specialist: "https://images.pexels.com/photos/919073/pexels-photo-919073.jpeg?auto=compress&cs=tinysrgb&w=2400",
  // Craft — extreme close-up of freshly refinished deep-black quarter panel.
  craft: "https://images.pexels.com/photos/17145727/pexels-photo-17145727.jpeg?auto=compress&cs=tinysrgb&w=2400",
  // Final CTA — red-taillight coupe on rain-soaked urban street at night.
  finalCta: "https://images.unsplash.com/photo-1517672651691-24622a91b550?auto=format&fit=crop&w=2600&q=85",
  // Secondary atmospheric imagery used across sections.
  paintReflection: "https://images.pexels.com/photos/17145727/pexels-photo-17145727.jpeg?auto=compress&cs=tinysrgb&w=1800",
  drift: "https://images.unsplash.com/photo-1577514075821-4c152f2bd5e0?auto=format&fit=crop&w=1800&q=80",
  aero: "https://images.pexels.com/photos/29755711/pexels-photo-29755711.jpeg?auto=compress&cs=tinysrgb&w=1800",
  portrait: "https://images.unsplash.com/photo-1645564977352-10a805bbdc1b?auto=format&fit=crop&w=1400&q=80",
  paintBooth: "https://images.unsplash.com/photo-1568844293986-8d0400bd4745?auto=format&fit=crop&w=1400&q=80",
  garage: "https://images.unsplash.com/photo-1487754180451-c456f719a1fc?auto=format&fit=crop&w=1800&q=80",
  wheels: "https://images.unsplash.com/photo-1626668893632-6f3a4466d22f?auto=format&fit=crop&w=1400&q=80",
  jdmSide: "https://images.unsplash.com/photo-1610647752706-3bb12232b3ab?auto=format&fit=crop&w=1800&q=80",
  neonStreet: "https://images.unsplash.com/photo-1493238792000-8113da705763?auto=format&fit=crop&w=2000&q=80",
  bodyPanel: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?auto=format&fit=crop&w=1400&q=80",
  masking: "https://images.unsplash.com/photo-1580273916550-e323be2ae537?auto=format&fit=crop&w=1400&q=80",
  // Services page — Category 03 (JDM & Specialty Vehicles). Supplied ProForm asset.
  servicesSpecialty: "https://customer-assets-agu9un31.emergentagent.net/job_proform-body/artifacts/bdhjubbn_change.png",
};

// Partner logos supplied by ProForm. Missile Works logo not yet supplied — remains text-only.
export const PARTNER_LOGOS = {
  "RevHard": "https://customer-assets-agu9un31.emergentagent.net/job_proform-body/artifacts/c94psgvh_revhard.webp",
  "MoFab": "https://customer-assets-agu9un31.emergentagent.net/job_proform-body/artifacts/7ipg4paf_mofab.webp",
  "Larimer Street Garage": "https://customer-assets-agu9un31.emergentagent.net/job_proform-body/artifacts/bssyb7b6_larimer%20street.webp",
};

// Central testIds map (kebab-case, descriptive)
export const TID = {
  nav: {
    root: "site-nav",
    logo: "nav-logo",
    linkWork: "nav-link-work",
    linkServices: "nav-link-services",
    linkAbout: "nav-link-about",
    linkPartners: "nav-link-partners",
    linkEstimate: "nav-cta-estimate",
    mobileToggle: "nav-mobile-toggle",
  },
  hero: {
    root: "hero",
    ctaEstimate: "hero-cta-estimate",
    ctaExplore: "hero-cta-explore",
    scrollHint: "hero-scroll-hint",
  },
  mobileBar: {
    root: "mobile-action-bar",
    call: "mobile-cta-call",
    text: "mobile-cta-text",
    estimate: "mobile-cta-estimate",
  },
  home: {
    manifesto: "section-manifesto",
    split: "section-two-sides",
    craft: "section-craft",
    services: "section-services",
    galleryTeaser: "section-gallery-teaser",
    cody: "section-cody",
    partners: "section-partners",
    process: "section-process",
    instagram: "section-instagram",
    finalCta: "section-final-cta",
  },
  estimate: {
    form: "estimate-form",
    submit: "estimate-submit",
    success: "estimate-success",
    reference: "estimate-reference",
    fileInput: "estimate-file-input",
    consent: "estimate-consent",
  },
  admin: {
    loginForm: "admin-login-form",
    email: "admin-login-email",
    password: "admin-login-password",
    submit: "admin-login-submit",
    dashboard: "admin-dashboard",
    estimatesTable: "admin-estimates-table",
    logout: "admin-logout",
  },
  footer: { root: "site-footer" },
};
